import clsx from "clsx";
import { ReactNode } from "react";

import { CardContainer } from "@/components/Layout/BaseLayouts/CardContainer";

interface ProductCardProps {
  dataTestid?: string;
  className?: string;
  header: ReactNode;
  footer: ReactNode;
}

export const ProductCard = ({
  dataTestid,
  className,
  header,
  footer,
}: ProductCardProps) => (
  <CardContainer
    dataTestid={dataTestid}
    className={clsx(
      // Fixed 328×445 tile -- content that doesn't fit is clipped rather
      // than growing the card (see overflow-hidden below). Inside a tile grid
      // the card fills its track instead; `product-card` is the hook for that
      // (see PortalDeviceTiles.scss).
      "product-card flex h-[445px] min-h-[445px] w-[328px] flex-col gap-4 overflow-hidden rounded-lg p-4",
      className,
    )}
    variant="ivory"
  >
    <div className="flex-1">{header}</div>
    <div className="w-full shrink-0">{footer}</div>
  </CardContainer>
);
